import gtag from '../analytics/gtag';
import type { UserData } from '../api/product';
import Icon from '../generic/Icon';
import { ProductReviewModal } from '../generic/Modals';
import useUser from '../login/userContext';
import * as style from './ProductRatingTool.module.css';

interface Props {
    productCode: string;
    rating: number | undefined;
    comment: string;
    onUserDataChange(userData: UserData): void;
}

export default function ProductRatingTool({ rating, comment, productCode, onUserDataChange }: Props) {
    const { showLoginModal } = useUser();

    const openModal = () => {
        if (!showLoginModal()) {
            ProductReviewModal.upsert({ rating, comment, productCode, onUserDataChange });
            gtag('event', 'modal_view', {
                modal_name: 'ProductRatingTool',
                item_id: productCode,
            });
        }
    };

    return (
        <button
            className="btn-icon"
            onClick={openModal}
            title={'Gi produkt opp til 5 stjerner.'}
            aria-label={'Gi produkt opp til 5 stjerner.'}
            style={{ '--rating': rating ?? 0 }}
        >
            <Icon className={style.ratingStar} />
        </button>
    );
}
